import {Injectable} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {UiService} from '../ui-service/ui.service';

@Injectable({
	providedIn: 'root'
})
export class RoutingService {

  private _CurrentRoute = new BehaviorSubject('');

  // get CurrentRoute () {
  //   return this._CurrentRoute.getValue();
  // }

  set CurrentRoute (value: string) {
    this._CurrentRoute.next(value);
  }

  listenToRouteChange = () => {
    return this._CurrentRoute.asObservable();
  }

  constructor(private router: Router, private UIService: UiService) {
    this.router.events.subscribe(event => {
      // this._CurrentRoute.next(event['url']);
      //
      if (event instanceof NavigationStart){
        this._CurrentRoute.next(event['url']);
      }
    });
	}


}
